import { useMemo } from 'react'

import { CirclePreset } from './presets'

import styles from './countdown.module.css'

interface Props {
  fraction: number
  preset: CirclePreset
}

const calculateCircumference = (radius: number) => 2 * Math.PI * radius

const FractionalCircle = ({ fraction = 0.5, preset }: Props) => {
  const { circle, strokeWidth } = useMemo(() => {
    return preset
  }, [preset])
  const circumference = useMemo(() => {
    return calculateCircumference(circle.r)
  }, [circle])
  const dashes = `${fraction * circumference} ${circumference}`
  return (
    <div className={styles.circleContainer}>
      <svg
        className={styles.svg}
        viewBox={`0 0 ${circle.r * 2 + 5} ${circle.r * 2 + 5}`}
      >
        <circle
          className={styles.strokeBackground}
          strokeWidth={strokeWidth}
          r={circle.r}
          cx={circle.cx}
          cy={circle.cy}
        ></circle>
        <circle
          className={styles.strokeCountdown}
          style={{ opacity: fraction > 0 ? 1 : 0 }}
          strokeWidth={strokeWidth}
          strokeDasharray={dashes}
          r={circle.r}
          cx={circle.cx}
          cy={circle.cy}
        ></circle>
      </svg>
    </div>
  )
}

export default FractionalCircle
